import React, { useContext, useState } from "react";

import { IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import TranslateIcon from "@material-ui/icons/Translate";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import { updateUser } from "../../services/users.api";

// `asMenuItem` (doc 0446): se dibuja como fila dentro del menú del usuario del modo simple.
const UserLanguageSelector = ({ asMenuItem = false, label, onDone }) => {
    const [langueMenuAnchorEl, setLangueMenuAnchorEl] = useState(null);

    const { user } = useContext(AuthContext);

    const handleOpenLanguageMenu = e => {
        setLangueMenuAnchorEl(e.currentTarget);
    };

    const handleCloseLanguageMenu = () => {
        setLangueMenuAnchorEl(null);
    };

    const handleChangeLanguage = async language => {
        try {
            await i18n.changeLanguage(language);
            await updateUser(user.id, { language });
        } catch (err) {
            toastError(err);
        }

        handleCloseLanguageMenu();
        if (onDone) onDone();
    };

    return (
        <>
            {asMenuItem ? (
                <MenuItem onClick={handleOpenLanguageMenu}>
                    <TranslateIcon fontSize="small" style={{ marginRight: 12 }} />
                    {label}
                </MenuItem>
            ) : (
            <Tooltip title="Idioma" arrow>
                <IconButton
                    size="small"
                    onClick={handleOpenLanguageMenu}
                    style={{ padding: "4px" }}
                >
                    <TranslateIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            )}
            <Menu
                anchorEl={langueMenuAnchorEl}
                keepMounted
                open={Boolean(langueMenuAnchorEl)}
                onClose={handleCloseLanguageMenu}
            >
                <MenuItem onClick={() => handleChangeLanguage("pt-BR")}>
                    <img src="https://flagcdn.com/w20/br.png" alt="BR" style={{ width: 20, height: 15, marginRight: 8, borderRadius: 2 }} />
                    {i18n.t("languages.pt-BR")}
                </MenuItem>
                <MenuItem onClick={() => handleChangeLanguage("en")}>
                    <img src="https://flagcdn.com/w20/us.png" alt="US" style={{ width: 20, height: 15, marginRight: 8, borderRadius: 2 }} />
                    {i18n.t("languages.en")}
                </MenuItem>
                <MenuItem onClick={() => handleChangeLanguage("es")}>
                    <img src="https://flagcdn.com/w20/es.png" alt="ES" style={{ width: 20, height: 15, marginRight: 8, borderRadius: 2 }} />
                    {i18n.t("languages.es")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserLanguageSelector;
